import React, { useEffect, useMemo, useRef, useState } from "react";
import { AddForm, EditForm, useTitle } from "../../components/layout";
import { useCreateContentMutation, useGetContentQuery } from "../../store";
import { useSearchParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import JoditEditor from "jodit-react";
import { ToastContainer } from "react-toastify";

const TACA = "TERMS_AND_CONDITIONS_APPRAISER";
const TACL = "TERMS_AND_CONDITIONS_LENDER";
const PPA = "PRIVACY_POLICY_APPRAISER";
const PPL = "PRIVACY_POLICY_LENDER";

const EditContent = () => {
  const [searchParams, _] = useSearchParams(document.location.search);
  const contentType = searchParams.get("TYPE");
  const title =
    contentType === "TACA" || contentType === "TACL"
      ? "Terms & Conditions"
      : "Privacy Policy";
  const queryType =
    contentType === "TACA" ? TACA :
      contentType === "TACL" ? TACL :
        contentType === "PPA" ? PPA :
          PPL;
  const {
    data,
    isLoading: isContentLoading,
    isError: isContentError,
    error: contentError,
    isSuccess: isContentSuccess,
  } = useGetContentQuery(queryType);

  const editor = useRef();
  const [value, setValue] = useState();
  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
      placeholder: "Write your content here...",
    }),
    []
  );

  const [
    updateContent,
    {
      isLoading: isCreateContentLoading,
      isError: isCreateContentError,
      error: createContentError,
      isSuccess: isCreateContentSuccess,
    },
  ] = useCreateContentMutation();

  useEffect(() => {
    if (editor.current) {
      const domScroll = document.querySelector(".jodit-workplace>div");
      domScroll.scrollTop = domScroll.scrollHeight;
    }
  }, [value]);

  const resetForm = () => setValue("");

  const submitHandler = async (e) => {
    e.preventDefault();

    let title;

    if (contentType === "TACA") {
      title = TACA;
    } else if (contentType === "PPA") {
      title = PPA;
    }
    else if (contentType === "TACL") {
      title = TACL;
    }
    else if (contentType === "PPL") {
      title = PPL;
    }

    updateContent({ title, content: value });
    if (isCreateContentSuccess) resetForm();
  };

  useEffect(() => {
    setValue(data?.content.content);
  }, [data?.content]);

  useTitle(`Content | ${title}`);

  return (
    <AddForm
      title={`Edit ${title}`}
      data={{}}
      setData={() => { }}
      inputFieldProps={[]}
      submitHandler={submitHandler}
      target="/admin/content"
      successMessage={`${title} Updated Successfully! Redirecting...`}
      reducerProps={{
        loading: isCreateContentLoading,
        error: createContentError,
        success: isCreateContentSuccess,
      }}
    >
      {isContentLoading ? (
        <Skeleton count={5} height={40} />
      ) : (
        <JoditEditor
          ref={editor}
          value={value}
          config={config}
          tabIndex={1} // tabIndex of textarea
          // onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
          onChange={(newContent) => setValue(newContent)}
        />
      )}
      {/* {content} */}
      <ToastContainer />
    </AddForm>
  );
};

export default EditContent;
